import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Header, Toast} from 'sabre-spark'
import ApplicationMenu from '../ApplicationMenu/index'
import menuConfig from 'config/menuConfig'
import appConfig from 'config/applicationConfig'
import LogoutPopover from "../LogoutPopover/index"
import toastIcon from "../../utils/toastIcon"


class ApplicationHeader extends Component {
    constructor(props) {
        super(props)
        this.toast = undefined
    }

    componentDidMount() {
        new Header(this.header)
    }

    componentDidUpdate() {
        if (this.props.message === undefined) return
        this.toast = new Toast(document.querySelector('[data-toast="header"]',
            {elHeader: document.querySelector('[data-toast="header"] .spark-header__nav')})
        )
        this.toast.open({
            title: this.props.message.title,
            details: this.props.message.text,
            icon: toastIcon(this.props.message.type),
            type: this.props.message.type,
            actionLabel: 'dismiss',
            duration: 5
        })
    }


    render() {
        return (
            <header className="spark-header spark-header--fixed" data-toast="header" ref={c => this.header = c}>
                <nav className="spark-header__nav">
                    <button className="spark-menu__toggle spark-header__toggle" title="View Navigation">
                        <i className="spark-icon--fill spark-icon-menu-hamburger spark-icon--md" />
                    </button>
                    <span className="spark-header__logo"><i
                        className="spark-logo spark-logo--sabre spark-logo--sm"/></span>
                    <Link to={'/'} className="spark-header__title">{appConfig.applicationTitle}</Link>
                    <ApplicationMenu menuConfig={menuConfig} activeMenuItem={this.props.activeMenuItem}/>
                    <LogoutPopover login={this.props.login}/>
                </nav>
            </header>
        )
    }
}

ApplicationHeader.propTypes = {
    login: PropTypes.string.isRequired,
    activeMenuItem: PropTypes.string.isRequired,
    message: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.oneOf(['positive', 'neutral', 'warning'])
    })
}

export default ApplicationHeader



// WEBPACK FOOTER //
// ./src/shared/components/ApplicationHeader/index.js